module.exports = __webpack_public_path__ + "img/noData.e963ad52.svg";